import submitReducer from '../../trade-approval/modules/01-submit/state/submit-slice'
import setEconomicsReducer from '../../trade-approval/modules/02-set-economics/state/set-economics-slice'
import tradeApproveReducer from '../../trade-approval/modules/03-approve/state/trade-approve-slice'
import tradeCommitmentReducer from '../../trade-approval/modules/04-commitment/state/trade-commitment-slice'
import tradeSettlementReducer from '../../trade-approval/modules/05-settlement/state/trade-settlement-slice'
import tradeActivateReducer from '../../trade-approval/modules/06-activate/state/trade-activate-slice'
import topupWithdrawReducer from '../../trade-editor/modules/01-topup-withdraw/state/topup-withdraw-slice'
import builderReducer from '../modules/00-builder/state/builder-slice'
import existingNoteReducer from '../modules/01-note/existing-note/existing-note-slice'
import noteSearchReducer from '../modules/01-note/existing-note/note-finder/note-search-slice'
import newNoteReducer from '../modules/01-note/new-note/new-note-slice'
import noteStepReducer from '../modules/01-note/note/note-step-slice'
import termsReducer from '../modules/02-terms/state/terms-slice'
import portfolioReducer from '../modules/03-portfolio/state/portfolio-slice'
import strategyReducer from '../modules/04-strategy/state/strategy-slice'
import completeReducer from '../modules/05-complete/complete-slice'

export const tradeBuilderReducers = {
  builder: builderReducer,
  note: noteStepReducer,
  newNote: newNoteReducer,
  existingNote: existingNoteReducer,
  noteSearch: noteSearchReducer,
  terms: termsReducer,
  portfolio: portfolioReducer,
  strategy: strategyReducer,
  complete: completeReducer,
  submit: submitReducer,
  setEconomics: setEconomicsReducer,
  tradeApprove: tradeApproveReducer,
  tradeCommitment: tradeCommitmentReducer,
  tradeSettlement: tradeSettlementReducer,
  tradeActivate: tradeActivateReducer,
  topupWithdraw: topupWithdrawReducer
}
